// extracted by mini-css-extract-plugin
export var active = "_2g-9";
export var backButton = "_2g-8";
export var clone = "_2g-e";
export var collapseBar = "_2g-j";
export var collapseMode = "_2g-l";
export var collapsed = "_2g-n";
export var dragHandle = "_2g-c";
export var dropdownIcon = "_2g-g";
export var expanding = "_2g-m";
export var hidden = "_2g-w";
export var iconContainer = "_2g-p";
export var iconSwapper = "_2g-v";
export var navItem = "_2g-6";
export var navItemIcon = "_2g-f";
export var navProfile = "_2g-7";
export var notificationCountBadge = "_2g-i";
export var notificationDot = "_2g-q";
export var optionsContainer = "_2g-h";
export var primaryNav = "_2g-0";
export var primaryNavDivider = "_2g-u";
export var primaryNavResizeHandle = "_2g-2";
export var primaryNavResizing = "_2g-1";
export var primaryNavTabSection = "_2g-t";
export var primaryTab = "_2g-o";
export var primaryTabIconBox = "_2g-r";
export var secondaryNav = "_2g-3";
export var selected = "_2g-s";
export var settingsNav = "_2g-4";
export var settingsNavItems = "_2g-5";
export var show = "_2g-d";
export var sideNav = "_2g-k";
export var teamItem = "_2g-a";
export var userProfileItem = "_2g-b";